<template>
  <div class="app-container" style="padding:30px 100px;">
    <el-form :model="data"  ref="addForm" label-width="100px">
      <el-form-item label="套餐名称:" prop="packageName">{{data.packageName}}</el-form-item>
      <el-form-item label="搭配模块:" prop="moduleList">
        <el-checkbox-group v-model="data.moduleList" :disabled="true">
          <el-checkbox label="marketing">营销模块</el-checkbox>
          <el-checkbox label="crm">CRM模块</el-checkbox>
          <el-checkbox label="account">账号模块</el-checkbox>
          <el-checkbox label="companyManage">公司管理模块</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="有效期:" prop="term">{{data.validity}}个月</el-form-item>
      <el-form-item label="账号数:" prop="term">{{data.accountNumMax}}</el-form-item>
      <el-form-item label="价格:" prop="name">
        <template v-if="data.price">{{amountFormat(data.price)}}元</template>
        <template v-else>免费</template>
      </el-form-item>
      <el-form-item label="说明:" prop="detail">
        <editor v-if="data.introduction" v-model="data.introduction" :contenteditable="false" :editorId="currentUserId" :editorContent="data.introduction"/>
      </el-form-item>
      <el-form-item>
        <el-button @click="cancel">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { packageDetail } from "@/api/saas/package";
import { mapState } from 'vuex'
import Editor from "@/components/wangEditor";
import { amountFormat } from "@/utils/index";

export default {
  components: {
    Editor
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  data() {
    return {
      amountFormat,
      loading: false,
      packageId: null,
      data: {
        accountNumMax: null,
        introduction: null,
        moduleList: [],
        packageName: null,
        price: null,
        validity: null
      }
    };
  },
  mounted() {
    this.packageId = this.$route.query.packageId;
    console.log("this.packageId ", this.packageId);
    this.queryDetail();
  },
  methods: {
    queryDetail() {
      packageDetail({
        packageId: this.packageId
      })
        .then(response => {
          this.data = response.data
        })
        .catch(error => {
          this.loading = false;
        });
    },
    cancel(){
      this.$router.go(-1)
    }
  }
};
</script>